import type { TFunction } from "i18next";

/**
 * Plural com as duas formas escritas a mao.
 *
 * A tela dizia `1 packages`, `1 objects` e, onde alguem percebeu o problema, o
 * paliativo `5 item(s)` — que erra sempre, so que discretamente. O plural nativo do
 * i18next (`chave_one` / `chave_other`) resolveria, mas as chaves com sufixo somem
 * do guarda de cobertura, que procura chave escrita a mao; a forma singular voltaria
 * em ingles sem ninguem notar.
 *
 * Por isso as duas formas entram como literais aqui: o guarda le as duas, e
 * `tp(t, n, ...)` fica com uma linha em vez de um ternario repetido em dez lugares.
 *
 * 🔶 Vale pra pt-BR/es-ES/en-US, que separam so singular de plural. Idioma com
 * forma dual ou paucal (ru, ar, pl) precisaria do plural nativo do i18next e de um
 * guarda que entenda os sufixos.
 */
export function tp(
  t: TFunction,
  n: number,
  singular: string,
  plural: string,
  vars: Record<string, unknown> = {},
): string {
  return Math.abs(n) === 1
    ? t(singular, { n, count: n, ...vars })
    : t(plural, { n, count: n, ...vars });
}
